// extracted by mini-css-extract-plugin
export default {"containerChar":"Card_containerChar__P8nSS","botonX":"Card_botonX__OEFYh","name":"Card_name__VrAaJ","containerData":"Card_containerData__MOQqh","fontW100":"Card_fontW100__sGbko"};